"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessageFromError = getMessageFromError;
exports.parseMessageFromJsonString = parseMessageFromJsonString;
var _json_utils = require("./json_utils");
/**
 * Get a user-friendly error message from any error.
 *
 * It extracts the message from a JSON string if necessary,
 * so that it works with errors thrown by unsuccessful API calls
 * (onRequestError will be called with an Error object with a message property
 * containing the response JSON as string)
 */
function getMessageFromError(error) {
  try {
    if (typeof error === 'string') {
      return parseMessageFromJsonString(error);
    } else if (error instanceof Error) {
      return parseMessageFromJsonString(error.message);
    } else if (error && error.message) {
      return error.message;
    }
  } catch (e) {}
}
function parseMessageFromJsonString(error) {
  if (!error || typeof error !== 'string') {
    return;
  }
  var parsed = (0, _json_utils.safeParseJson)(error);
  if (parsed && parsed.message) {
    return parsed.message || parsed.error.toString() || error;
  }
  return error;
}